import { render } from "./SBPMap.vue?vue&type=template&id=66dfd595"
import script from "./SBPMap.vue?vue&type=script&lang=js"
export * from "./SBPMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__